//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import {Swipe, SwipeItem, Progress, MessageBox} from 'mint-ui'
    import api from '@/api/index'
    import footerNav from '@/components/footer/footer'
    import util from '@/utils'
    import imgpath from '../../../src/assets/images/classposter1.jpg'
    import utils from '@/utils/utils.js'

    export default {
        name: "newindex",
        components: {
            footerNav
        },
        data(){
            return{
                val:20,
                cur:0,
                // 轮播图
                bannerList:[
                    /*{imgpic:require('../../assets/images/banner1.jpg')},
                    {imgpic:require('../../assets/images/banner1.jpg')},
                    {imgpic:require('../../assets/images/banner1.jpg')}*/
                ],
                //导航
                navlist:[

                ],
                //课程分类
                classlist:[

                ],
                //课程内容
                classconlist:[

                ],
                coursetype:'SPECIALABILITY',
                logined: true,
                continueCourse:{
                    coverpath:imgpath,
                    title:"焊工",
                    nextLength:"0分0秒",//剩余时长
                    lessonDuration:"0分0秒",//总时长
                    lessonCount:0,//总课时数
                    record:0,//进度百分比
                    progress:'',
                    courseId:1//课程编号
                }
            }
        },
        created() {
            this.logined = util.checkUserLogined();
            console.log(22)
            this.getclasslist(this.coursetype);
        },
        mounted() {
            api.getContunueCourse({
            }).then(resp => {
                let response = resp.result.data;

                let coverpath = response.coverpath;
                let mediasum = response.mediasum;
                let playsum = response.playsum;
                let title = response.title;
                let continueCourseId = response.courseid;

                let residueMin = Math.floor((mediasum-playsum)/1000/60);
                let residueSin = Math.floor((mediasum-playsum-residueMin*1000*60)/1000)
                let residue = residueMin+"分"+residueSin+"秒";
                let record = Math.floor(playsum/mediasum*100);
                let lessonCount = Math.floor(mediasum/1000/60/45);

                let overMin = Math.floor(mediasum/1000/60);
                let overSin = Math.floor((mediasum-overMin*1000*60)/1000);
                let over = overMin+"分"+overSin+"秒";

                this.continueCourse.coverpath = "https://imagesbj.sdjtip.com/"+coverpath+"?x-oss-process=image/resize,m_fill,w_220,h_156";
                this.continueCourse.title = title;
                this.continueCourse.nextLength = residue;
                this.continueCourse.record = record;
                this.continueCourse.lessonCount = lessonCount;
                this.continueCourse.lessonDuration = over;
                this.continueCourse.courseId = continueCourseId
                this.continueCourse.progress = response.myprogress;
                this.continueCourse.progressDesc=utils.getProgressDesc(response.myprogress)
            }).catch((resp) => {

            })
            this.getCourseTypeList();
        },
        methods:{
           /* getclass(index,coursetype){
                this.coursetype = coursetype
                this.cur = index
                this.getclasslist();
            },*/
            //导航跳转
            goallclass(index,coursetype){
                console.log(index)
                this.$router.push({
                    path: '/classList',
                    query:{
                        cur:index,
                        coursetype:coursetype
                    }
                });
            },
            //跳转
            gonext(id){
                this.$router.push({
                    path: '/index/courseInfo',
                    query:{
                        courseid:id
                    }
                });
            },
            goToLogin() {
                this.$router.push({path: '/login'})
            },
            courseListInfo() {
                this.$router.push({
                    path: '/personal/school/courseListInfo',
                    // schoolId: this.mySchool.schoolid
                })
            },
            routerToDetail(courseid) {
                this.$router.push({
                    path: '/index/courseInfo',
                    query: {
                        courseid: courseid
                    }
                })
            },
            getclass(index,coursetype){
                this.coursetype = coursetype
                console.log(coursetype);
                this.cur = index
                this.getclasslist();
            },
            getclasslist(){
                var coursetype = this.coursetype;
                // 获取首页数据(轮播图
                api.getIndex({
                    params: {
                        pagesize:'',
                        coursetype:this.coursetype,
                        yumingHost:window.location.host
                    }
                }).then(resp => {
                    let courselist = resp.result.courselist;
                    this.classconlist = [];
                    this.bannerList= resp.result.bannerList;
                    console.log(1)
                    console.log(resp.result)
                    for(let index in courselist){
                        let min = Math.floor(courselist[index].mediaDuration/1000/60);
                        let sen = Math.floor(courselist[index].mediaDuration/1000-min*60);
                        let courseobj = {
                            courseid:courselist[index].courseid,
                            //conpic:require('../../assets/images/poster1.jpg'),
                            conpic:courselist[index].iconurl+"?x-oss-process=image/resize,m_fill,w_220,h_156",
                            contitle:courselist[index].title,
                            classnum:courselist[index].duration,
                            classtime:min+'分'+sen+'秒',
                            price:'',
                            //userpic:require(courseList[index].iconurl),
                            userpic:courselist[index].iconurl+"?x-oss-process=image/resize,m_fill,w_220,h_156",
                            username:courselist[index].teacher?courselist[index].teacher.length>8?courselist[index].teacher.substr(0,8)+"...":courselist[index].teacher:'',
                            //username:courselist[index].teacher,
                            usernum:courselist[index].studyCount
                        };

                        this.classconlist.push(courseobj);
                    }
                }).catch((resp) => {
                    console.log(resp);
                })
            },
            getCourseTypeList(){
                // 获取首页数据(轮播图
                api.getCourseTypeList({
                    params: {
                    }
                }).then(resp => {
                    let courseTypeList = resp.data;
                    console.log(courseTypeList);
                    console.log("courseTypeList");
                    let maxShowNum=courseTypeList.length>3?3:courseTypeList.length;
                    for (let i = 0; i < courseTypeList.length; i++) {
                        if(i<maxShowNum){
                            this.navlist.push({href:'www/baodu.com',navpic:courseTypeList[i].mobileIcon,anvname:courseTypeList[i].courseTypeName,coursetype:courseTypeList[i].courseType});
                        }
                        this.classlist.push({classname:courseTypeList[i].courseTypeName,coursetype:courseTypeList[i].courseType});
                    }
                    this.navlist.push({href:'www/baodu.com',navpic:'https://zyfl-static.oss-cn-qingdao.aliyuncs.com/img/mobile/navicon4.png',anvname:'更多课程'});
                    console.log(this.navlist);
                }).catch((resp) => {
                    console.log(resp);
                    console.log("courseTypeList2");
                })
            }
        }
    }



// WEBPACK FOOTER //
// ./src/view/index/lzindex.vue